/* GH-1133 S5 (design §2.4): the routes a free-preview account may open,
   modelled on postingAccess.js. Composed with PostingRouteOutlet (App.jsx):
   allowed → the routed screen; 'plans' → the trial wall over the board
   (never Plans.jsx, whose plain checkout has no trial); everything else →
   PreviewFeatureLock (S10) with the wall source its CTA opens. */

const ALLOWED_EXACT = new Set([
  '/app',
  '/app/library',
  '/app/research',
  '/app/brandkit',
  '/app/settings',
  // The onboarding connect step's OAuth returns here; MainApp then resumes
  // /onboarding (ONBOARDING_SOCIAL_RETURN_KEY), so it must stay reachable.
  '/app/settings/integrations',
  // Read-only help content (deviation from §2.4's "unknown /app/* → S10": a
  // "Help center opens with your trial" lock would be false).
  '/app/help',
]);

const LABEL_KEYS = {
  plan: 'sidebar.navContentPlan',
  strategy: 'topbar.editStrategy',
  create: 'sidebar.newPost',
  edit: 'topbar.editPost',
  calendar: 'sidebar.navCalendar',
  messages: 'topbar.messages',
  batch: 'topbar.batchProgress',
  referrals: 'sidebar.referrals',
  other: 'sidebar.navMore',
};

function trimSlash(pathname) {
  const path = String(pathname || '');
  return path.length > 1 && path.endsWith('/') ? path.slice(0, -1) : path;
}

export function previewRouteDecision(pathname = '') {
  const path = trimSlash(pathname);
  if (path !== '/app' && !path.startsWith('/app/')) return { kind: 'allow' };
  if (ALLOWED_EXACT.has(path)) return { kind: 'allow' };
  if (path.startsWith('/app/reveal/')) return { kind: 'allow' };
  if (path.startsWith('/app/research/print/')) return { kind: 'allow' };
  if (path === '/app/plans' || path.startsWith('/app/plans/')) return { kind: 'plans' };
  if (/^\/app\/post\/[^/]+\/edit$/.test(path)) return { kind: 'lock', feature: 'edit', source: 'edit' };
  if (/^\/app\/post\/[^/]+$/.test(path)) return { kind: 'allow' };
  if (path === '/app/create' || path.startsWith('/app/create/')) return { kind: 'lock', feature: 'create', source: 'generate' };
  if (path === '/app/plan/edit-strategy') return { kind: 'lock', feature: 'strategy', source: 'feature' };
  if (path === '/app/plan' || path.startsWith('/app/plan/')) return { kind: 'lock', feature: 'plan', source: 'feature' };
  if (path === '/app/calendar' || path.startsWith('/app/calendar/')) return { kind: 'lock', feature: 'calendar', source: 'feature' };
  if (path === '/app/messages' || path.startsWith('/app/messages/')) return { kind: 'lock', feature: 'messages', source: 'feature' };
  if (path.startsWith('/app/batch/')) return { kind: 'lock', feature: 'batch', source: 'feature' };
  if (path === '/app/referrals' || path.startsWith('/app/referrals/')) return { kind: 'lock', feature: 'referrals', source: 'feature' };
  return { kind: 'lock', feature: 'other', source: 'feature' };
}

export function previewFeatureLabelKey(feature) {
  return LABEL_KEYS[feature] || LABEL_KEYS.other;
}
